import { useQuery } from "@apollo/client";
import { GET_CAR_OWNERS } from "../../graphql/AdminQueries";

/**
 * Fetches only the car owners list for the list page.
 * No products or pricelist - keeps the list page lightweight.
 */
const useCarOwnersList = (loadData) => {
  const graphqlVariables = {
    tokenGet: process.env.REACT_APP_TOKEN_GET,
  };
  const result = useQuery(GET_CAR_OWNERS, {
    variables: graphqlVariables,
    skip: !loadData,
  });
  const data = result.data?.getCarOwners;
  return {
    ...result,
    owners: Array.isArray(data) ? data : [],
  };
};

export { useCarOwnersList };
